import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function RodJackson() {
  const rodJacksonSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Rod Jackson",
    "jobTitle": "Senior Advisor",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/rod-jackson"
  };

  return (
    <div className="corporateAdvisorsBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Rod Jackson - Senior Advisor"
        description="Rod is non-executive director on a range of businesses both domestically and internationally, with extensive experience in financial services."
        keywords={['Rod Jackson', 'Senior Advisor', 'Financial Services', 'Business Leadership', 'Westpac']}
        ogImage="/rodJackson.webp"
        schema={rodJacksonSchema}
      />

      <div className="xl:page-width px-12 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[2rem]" aria-label="Breadcrumb">
          <Link to="/leadership/corporate-advisors" className="text-white hover:text-primary-red transition-colors">
            Corporate Advisors
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Rod Jackson</span>
          </div>
        </nav>

        <div className="flex flex-col gap-2 md:gap-4 pt-24">
          <div className="text-[4.8rem] font-bold leading-[5.1rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Rod Jackson
          </div>
          <div className="font-syne font-bold text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Senior Advisor
          </div>
        </div>
      </div>

      <div className="pt-[50px] xl:pt-[90px] xl:pb-[80px] xl:page-width px-12">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/rodJackson.webp" 
                alt="Rod Jackson, Senior Advisor - Financial Services and Business Leadership Expert" 
                className="w-full max-w-[300px] mx-auto md:max-w-[300px] md:mx-0"
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="font-sans text-[2.1rem] leading-[3.1rem] tracking-[.042rem] text-white">
                Rod is non-executive director on a range of businesses both domestically and internationally. Rod is Chair of Westpac Europe Ltd based in London and Adviser to Executive Global Network in Singapore. Domestically, Rod is a Director of Newcastle Greater Mutual Group, Director of NextSense, Director of Financial Services Institute of Australasia, Director of Searson Buck Group and Chair of the ODEO Group. He has been a director in financial services, recruitment, property management and e-commerce for 15 years.
                Rod has worked as an executive in financial services, primarily at Westpac Banking Corporation, for over 40 years. 11 of which have been in Asia and Europe. For the last twenty years Rod has been either a CFO or COO across numerous roles including Westpac Retail and Business Bank and the St George Banking Group. Rod retired from executive life in January 2021 from the CFO, Westpac Institutional Bank role.
                Rod holds a Bachelor of Economics (with specialisation in Accounting) from ANU, Canberra, Australia and an MBA from the International Institute for Management Development in Lausanne, Switzerland.
              </div>
            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="rod-jackson" 
        basePath="/leadership" 
      />
    </div>
  );
}